<div class="mms-worksheet p-20 m-0-auto">

    <!-- <div class="text-a-right">
        <button nz-button class="m-r-20" [nzType]="'primary'" translate (click)="downloadPDF()">Download</button>
    </div> -->
    <div id="uwWorksheetSection">
    <!-- Header -->
    <ng-container *ngIf="riskSummarizationLoader">
        <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
          <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Loading Risk Summarization...</p>
        </div>
      </ng-container>

    <div *ngIf="!riskSummarizationLoader" class="mms-ws-header">
        <div class="flex flex-horiz-space-bw">
            <div>
                <img src="/assets/images/{{organizationMetaData.logoname}}" alt="LOGO" class="mms-ws-header-logo"
                    style="height: 50px;margin-bottom: 15px" />
            </div>
            <div>
                <h4 class="p-0 m-0"></h4>
                <span class="col-grey-dark"> </span>
            </div>
            <div class="mms-ws-header-addr">
                <!-- Ninad's Review: This has to be changed, please understand which address is to be populated below.  -->
                <!-- <h5>MetaMorphoSys Insurance Corp.</h5>
        <p>Himgiri Bungalow, LA-Ratan Lane</p>
        <p>Baner, MH 411045</p> -->
            </div>
        </div>
    </div>

    <!-- Claim Details -->
    <ng-container *ngIf="riskSummarizationContent && refreshModal; else showNoRiskSummaryContent">
        <div *ngIf="overallRisk">
            <span class="heading" style="font-weight: 700; font-size: 1.5em;">Overall Proposal Risk : </span>
            <span [ngClass]="{'font-green' : overallRisk == 'Low', 'font-orange' : overallRisk == 'Medium', 'font-red' : overallRisk == 'High'}" style="font-weight: 700; font-size: 1.5em;">{{overallRisk}}</span>
        </div>
        <!-- <div class="unselectable" [innerHTML]="riskSummarizationContent | safeHtml "></div> -->
        <app-markdown title="Underwriter Risk Summary" [textContent]="riskSummarizationContent"></app-markdown>
    </ng-container>
    <ng-template #showNoRiskSummaryContent>
        <ng-container *ngIf="!riskSummarizationLoader">
            <nz-result nzStatus="500" nzTitle="Loading Risk Summarization...">
                <!-- nzSubTitle="Please contact administrator if the issue persists." -->
                <!-- <div nz-result-extra> <button nz-button nzType="primary">Back Home</button> </div> -->
            </nz-result>
        </ng-container>
        <!-- has context menu -->
    </ng-template>
    <!-- Updated Risk Summarization -->
    <div *ngIf="showRiskSummaryTable">
        <ng-container *ngIf="riskSummarizationResponse; else showNoRiskSummary">
            <div class="grid grid-gap-10">
                <div *ngIf="riskSummarizationResponse.overall_risk">
                    <span class="heading" style="font-weight: 700; font-size: 1.5em;">Overall Proposal Risk : </span>
                    <span [ngClass]="{'font-green' : riskSummarizationResponse.overall_risk == 'Low', 'font-orange' : riskSummarizationResponse.overall_risk == 'Medium', 'font-red' : riskSummarizationResponse.overall_risk == 'High'}" style="font-weight: 700; font-size: 1.5em;">{{riskSummarizationResponse.overall_risk}}</span>
                </div>
                <div *ngIf="riskSummarizationResponse.overall_recommendation">
                    <span class="heading" style="font-weight: 600;">Overall Proposal Recommendation : </span>
                    <span *ngIf="userDetails && userDetails.recommendation;">{{userDetails.recommendation}}</span>
                </div>
                <!-- <span *ngIf="riskSummarizationResponse.overall_recommendation">Overall Proposal Recommendation : {{riskSummarizationResponse.overall_recommendation}}</span> -->
            </div>
            <div>
                <ng-container>
                    <!-- <i nz-icon nzType="issues-close"></i> Criteria wise risk summarization -->
                    <div class="heading-tab panel-custom-unified-collapse-heading m-b-20 m-t-20">
                        <h3 class="heading"><i nz-icon nzType="issues-close"></i> Criteria wise risk summarization</h3>
                    </div>
                </ng-container>
                <nz-table #riskSummarization [nzData]="riskSummarizationResponse.criteria_wise_risk_list" [nzShowPagination]="false">
                    <thead class="table-header">
                    <tr>
                        <th class="">Criteria</th>
                        <th class="">Risk Level</th>
                        <th class="">Recommendation</th>
                    </tr>
                    </thead>
                    <tbody class="">
                    <tr class="table-row" *ngFor="let criteria of riskSummarization.data">
                        <td class="">{{ criteria.criteria_value}}</td>
                        <td [ngClass]="{'font-green' : criteria.criteria_risk_level == 'Low', 'font-orange' : criteria.criteria_risk_level == 'Medium', 'font-red' : criteria.criteria_risk_level == 'High'}">{{ criteria.criteria_risk_level}}</td>
                        <td class="">{{ criteria.criteria_risk_description}}</td>
                    </tr>
                    </tbody>
                </nz-table>
            </div>
        </ng-container>
        <ng-template #showNoRiskSummary>
            <ng-container *ngIf="!riskSummarizationLoader">
            <nz-result nzStatus="500" nzTitle="Oops! There seems to be some problem with extraction." nzSubTitle="Please contact administrator if the issue persists.">
                <!-- <div nz-result-extra> <button nz-button nzType="primary">Back Home</button> </div> -->
            </nz-result>
        </ng-container>
            <!-- has context menu -->
        </ng-template>
    </div>
    </div>
</div>